
export class OmkorningRelationerLagertransaktionRequestDTO {

    kor: Kortyp;
    matdatumFrom: string;
    matdatumTom: string;
    kundHuvudkodInternnummer: string;
    mottagningsplatsNummer: string;
    leveransnummer: string;

    constructor() {
        this.kor = undefined;
        this.matdatumFrom = undefined;
        this.matdatumTom = undefined;
        this.kundHuvudkodInternnummer = undefined;
        this.mottagningsplatsNummer = undefined;
        this.leveransnummer = undefined;
    }
}

export enum Kortyp {
    Alla = 0,
    SaknarKundorder = 1,
}
